import { render, staticRenderFns } from "./prod.vue?vue&type=template&id=f988e8ba&scoped=true&"
import script from "./prod.vue?vue&type=script&lang=js&"
export * from "./prod.vue?vue&type=script&lang=js&"
import style0 from "./prod.vue?vue&type=style&index=0&id=f988e8ba&lang=scss&scoped=true&"
import style1 from "./prod.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f988e8ba",
  null
  
)

export default component.exports